import { render, staticRenderFns } from "./ToDeliver.vue?vue&type=template&id=1360ff86&"
import script from "./ToDeliver.vue?vue&type=script&lang=js&"
export * from "./ToDeliver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports